function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as Exporter from './exporter';
import _ from 'underscore';
var AlignmentExporter = /*#__PURE__*/function () {
  function AlignmentExporter() {
    _classCallCheck(this, AlignmentExporter);
    this.prepare_alignments_for_export = this.prepare_alignments_for_export.bind(this);
    this.export_alignments = this.export_alignments.bind(this);
  }
  return _createClass(AlignmentExporter, [{
    key: "wrap_string",
    value: function wrap_string(str, width) {
      return str.match(new RegExp(".{1,".concat(width, "}"), 'g')).join('\n');
    }
  }, {
    key: "generate_fasta",
    value: function generate_fasta(hsps) {
      var fasta = '';
      hsps.map(function (hsp) {
        fasta += ">".concat(hsp.query_id, ":").concat(hsp.qstart, "-").concat(hsp.qend, "\n");
        fasta += "".concat(hsp.qseq, "\n");
        fasta += ">".concat(hsp.query_id, ":").concat(hsp.qstart, "-").concat(hsp.qend, "_alignment_").concat(hsp.hit_id, ":").concat(hsp.sstart, "-").concat(hsp.send, "\n");
        fasta += "".concat(hsp.midline, "\n");
        fasta += ">".concat(hsp.hit_id, ":").concat(hsp.sstart, "-").concat(hsp.send, "\n");
        fasta += "".concat(hsp.sseq, "\n");
      });
      return fasta;
    }
  }, {
    key: "get_alignments_download_metadata",
    value: function get_alignments_download_metadata(hsps, filename_prefix) {
      var fasta = this.generate_fasta(hsps);
      var blob = new Blob([fasta], {
        type: 'text/fasta'
      });
      var filename = Exporter.sanitize_filename(filename_prefix) + '.txt';
      return {
        filename: filename,
        blob: blob
      };
    }
  }, {
    key: "prepare_alignments_for_export",
    value: function prepare_alignments_for_export(hsps, filename_prefix) {
      var _this$get_alignments_ = this.get_alignments_download_metadata(hsps, filename_prefix),
        filename = _this$get_alignments_.filename,
        blob = _this$get_alignments_.blob;
      return Exporter.generate_blob_url(blob, filename);
    }
  }, {
    key: "export_alignments",
    value: function export_alignments(hsps, filename_prefix) {
      var _this$get_alignments_2 = this.get_alignments_download_metadata(hsps, filename_prefix),
        filename = _this$get_alignments_2.filename,
        blob = _this$get_alignments_2.blob;
      Exporter.download_blob(blob, filename);
    }
  }]);
}();
export { AlignmentExporter as default };